"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var opacityTextSubtle = exports.opacityTextSubtle = 0.75;
var opacityTextDisabled = exports.opacityTextDisabled = 0.3;
var opacityBackgroundOverlayModal = exports.opacityBackgroundOverlayModal = 0.9;
var opacityBackgroundOverlayHeavy = exports.opacityBackgroundOverlayHeavy = 0.75;
var opacityBackgroundOverlayLight = exports.opacityBackgroundOverlayLight = 0.3;
var opacityBackgroundSubtle = exports.opacityBackgroundSubtle = 0.15;
var opacityBackgroundActive = exports.opacityBackgroundActive = 0.08;
var opacityBackgroundDisabled = exports.opacityBackgroundDisabled = 0.05;
var opacityBackgroundHover = exports.opacityBackgroundHover = 0.04;
var opacityBorder = exports.opacityBorder = 0.2;
var opacityShadow = exports.opacityShadow = 0.1;
var opacityInputBorderFocused = exports.opacityInputBorderFocused = 0.5;
var opacityInputBorderValid = exports.opacityInputBorderValid = 0.4;
var opacityInputBorderInvalid = exports.opacityInputBorderInvalid = 0.25;